import React from 'react';

import { Button } from '../../components/Field';
import Title from '../Title';
import Editor from '../Editor';
import Spacer from '../Spacer';
import Background from '../Background';
import Section from '../../components/Section';
import BackgroundImage from "../../assets/image/notfoundbg.jpeg";

import style from './style.module.css';

const NoMatch = (props) => {
    const {
        label = "Go to Home",
        link = "/",
        color = "buttonPrimary",
        title = "Oops",
        text = "We can't seem to find the page you're looking for.",
        background = false,
        secondaryButtonLabel="",
        secondaryButtonLink="",
    } = props;

    return (
        <>
            {
                title !== "No search result" && (
                    <Section id="noMatch" className={`${title === "No search result" ? style.searchNoMatch : ""} ${style.nomatchSection}`}>
                        <Background src={background === true ? BackgroundImage : background !== false ? background : BackgroundImage} size="2560x1440" />
                        {
                            title === "No saved articles" && (
                                <div>No saved articles</div>
                            )
                        }
                        {
                            title !== "No saved articles" && (
                                <div className={title === "No search result" ? style.searchNoMatch : style.noMatch}>
                                    <div className={style.sectionRow}>
                                        <div className={style.sectionHeader}>
                                            <Title className="fontTeko" transform="uppercase">{title}</Title>
                                        </div>
                                        <div className={style.sectionBody}>
                                            <Editor text={text} />
                                        </div>
                                        <div className={style.sectionFooter}>
                                            <Spacer />
                                            <Button
                                                link={link}
                                                label={label}
                                                color={color}
                                            />
                                            {
                                                secondaryButtonLabel !== "" && secondaryButtonLink !== "" && (
                                                    <Button
                                                        link={secondaryButtonLink}
                                                        label={secondaryButtonLabel}
                                                        color="buttonPrimaryWithOutBg"
                                                    />
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </Section>
                )
            }
        </>
    )
}

export default NoMatch